module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="team-builder-controls-container">\n	<div class="team-builder-controls-left">\n		<div class="trades-info">\n			<h5 class="team-info-title">Trades remaining</h5>\n			<span class="team-info-value">\n				';
 if(is_unlimited_trades){ 
__p+='\n					UNL\n				';
 } else { 
__p+='\n					'+
((__t=( _.result(team, 'season_trades_left', '-') ))==null?'':_.escape(__t))+
'('+
((__t=( _.result(team, 'week_trades_left', '-') ))==null?'':_.escape(__t))+
')\n				';
 } 
__p+='\n			</span>\n		</div>\n\n		<div class="salary-cap-info">\n			<h5 class="team-info-title">Salary Remaining</h5>\n			<span class="team-info-value '+
((__t=( remaining_salary < 0 ? 'negative' : '' ))==null?'':_.escape(__t))+
'">\n				'+
((__t=( _.currencyFormat(remaining_salary, '$', true) ))==null?'':_.escape(__t))+
'\n			</span>\n		</div>\n		<div class="team-value-info">\n			<h5 class="team-info-title">Team Value</h5>\n			<span class="team-info-value">\n				'+
((__t=( _.currencyFormat(team_value) ))==null?'':_.escape(__t))+
'\n			</span>\n		</div>\n	</div>\n	<div class="team-builder-controls-right">\n		<div class="team-field-next-lockout">\n			<h5>Next Lockout</h5>\n			<div class="js-team-field-next-lockout-timer next-lockout-timer" data-start-at="'+
((__t=( next_lockout ))==null?'':_.escape(__t))+
'"></div>\n		</div>\n	</div>\n</div>';
}
return __p;
};
